<mat-toolbar class="custom-toolbar border-bottom bg-white px-3">
  
  <div class="d-flex align-items-center">
    <mat-icon color="primary" class="toolbar-logo-icon me-2">circle</mat-icon>
    <span class="toolbar-title fw-semibold text-dark">{{ 'Rapport de suivi' }}</span>
  </div>
  
  <span class="title-spacer flex-grow-1"></span>

</mat-toolbar>


<mat-card appearance="outlined" class="main-table-card border-0 shadow-sm mt-5">
  <mat-card-header class="d-flex justify-content-end">
      <app-search-bar-component (searchBarValue)="applyFilter($event)" class=""></app-search-bar-component>
      <div class="d-flex justify-content-around ms-4">
        <button [disabled]="rapportData.length == 0" (click)="saveRapport()" matTooltip="Transmettre le rapport" mat-raised-button class="btnAdd bg-mat-blue mx-1 py-4">
          <mat-icon>sync_alt</mat-icon>
          <span>Transmettre ({{ rapportData.length }})</span>
        </button>
        <button (click)="openExportModal()" matTooltip="Exporter le rapport vers excel" mat-raised-button class="btnAdd bg-mat-cyan mx-1 py-4">
          <mat-icon>file_export</mat-icon>
          <span>Exporter</span>
        </button>
      </div>
  </mat-card-header>

    <mat-card-content class="position-relative p-0 bg-white table-mat-card-content">
      <!--loading-->
      @if (loading()) {
      <div class="loading-table-shade">
        <mat-spinner diameter="70" color="primary"></mat-spinner>
      </div>
      }

      <!---->
      <div>
      <div class="table-responsive">
        <table mat-table [dataSource]="dataSource" matSort class="w-100 custom-premium-table">
        <!-- -->
        <ng-container matColumnDef="assure">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Assure </th>
          <td mat-cell *matCellDef="let row"  data-label="Assure"> {{row.assure}} </td>
        </ng-container>

        <ng-container matColumnDef="categorie">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Categorie </th>
          <td mat-cell *matCellDef="let row"  data-label="Categorie"> {{ row.categorie }} </td>
        </ng-container>

        <ng-container matColumnDef="puissance_en">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Puissance & Energie </th>
          <td mat-cell *matCellDef="let row"  data-label="Puissance & Energie"> {{ row.puissance+' CV '+(row.energie??'') }}</td>
        </ng-container>

        <ng-container matColumnDef="dta">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> DTA </th>
          <td mat-cell *matCellDef="let row"  data-label="DTA"> {{ row.vignette }} </td>
        </ng-container>

        <ng-container matColumnDef="attestation">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Attestation </th>
          <td mat-cell *matCellDef="let row"  data-label="Attestation"> {{ row.attestation }} </td>
        </ng-container>

        <ng-container matColumnDef="carte_rose">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Carte rose </th>
          <td mat-cell *matCellDef="let row"  data-label="Attestation"> {{ row.carte_rose }} </td>
        </ng-container>

        <ng-container matColumnDef="effet">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Date effet </th>
          <td mat-cell *matCellDef="let row"  data-label="Date effet"> {{ row.date_effet | date }} </td>
        </ng-container>

        <ng-container matColumnDef="fin">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Date fin </th>
          <td mat-cell *matCellDef="let row"  data-label="Date fin"> {{ row.date_fin | date}} </td>
        </ng-container>

        <ng-container matColumnDef="compagnie">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Compagnie </th>
          <td mat-cell *matCellDef="let row"  data-label="Compagnie"> {{ row.compagnie_name }} </td>
        </ng-container>

        <ng-container matColumnDef="produit_le">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true"> Produit le </th>
          <td mat-cell *matCellDef="let row"  data-label="Compagnie"> {{ row.created_at | date }} </td>
        </ng-container>

        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sticky="true">
            <mat-checkbox (change)="$event ? toggleAllRows() : null"
                    [checked]="selection.hasValue() && isAllSelected()"
                    [indeterminate]="selection.hasValue() && !isAllSelected()"
                    [aria-label]="checkboxLabel()">
            </mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let row"  data-label="">
              <mat-checkbox (click)="$event.stopPropagation(); selectAssurance(row)"
                            (change)="$event ? selection.toggle(row) : null"
                            [checked]="selection.isSelected(row)"
                            [aria-label]="checkboxLabel(row)">
              </mat-checkbox>
          </td>
        </ng-container>


        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        <!-- Row shown when there is no matching data. -->
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="4">No data matching the filter "{{searchValue()}}"</td>
        </tr>
            </table>
      </div>      </div>
  </mat-card-content>

  <div class="border-top bg-white">
      <mat-paginator [pageSizeOptions]="[6, 10, 25, 100]" aria-label="Select page of users"></mat-paginator>
  </div>
</mat-card>
